// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layer-search {
  padding: 0.5rem;
  margin-bottom: 20px; }
  .layer-search .input-group {
    width: 100%; }
    .layer-search .input-group .icon-wrapper {
      border: none;
      border-top-left-radius: 3px;
      border-bottom-left-radius: 3px; }
      .layer-search .input-group .icon-wrapper svg {
        color: #dcd7d7; }
    .layer-search .input-group input {
      background-color: #002754;
      border-top-right-radius: 3px;
      border-bottom-right-radius: 3px;
      color: #cfc9c9;
      border: none; }
      .layer-search .input-group input::placeholder {
        color: #dcd7d7; }
      .layer-search .input-group input:focus {
        box-shadow: unset; }
    .layer-search .input-group:focus-within {
      box-shadow: 0 0 0 0.25rem #01254fd4;
      border-radius: 3px; }
    .layer-search .input-group .icon-wrapper,
    .layer-search .input-group input {
      background-color: #01254f;
      color: #dcd7d7; }
  .layer-search .btn-clear {
    color: white;
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px; }

.queried-layers {
  max-height: 300px;
  overflow-y: auto;
  background-color: #0E1937;
  color: #dcd7d7;
  border-radius: 3px; }

.suggestions-list {
  border-radius: unset;
  width: 100%;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  background-color: #03274E; }
  .suggestions-list .list-group-item {
    background-color: #03274E;
    color: white;
    border: none; }
    .suggestions-list .list-group-item:hover {
      background-color: #00153375;
      color: white; }
  .suggestions-list button {
    background-color: #002044b5;
    color: white;
    border: none; }
    .suggestions-list button:hover {
      background-color: #00153375;
      color: white; }
`, "",{"version":3,"sources":["webpack://./src/layout/Layers/LayerSearch/layer-search.scss"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,mBAAmB,EAAA;EAFrB;IAKI,WAAW,EAAA;IALf;MAQM,YAAY;MACZ,2BAA2B;MAC3B,8BAA8B,EAAA;MAVpC;QAYQ,cAAc,EAAA;IAZtB;MAiBM,yBAAyB;MACzB,4BAA4B;MAC5B,+BAA+B;MAC/B,cAAc;MACd,YAAY,EAAA;MArBlB;QAwBQ,cAAc,EAAA;MAxBtB;QA4BQ,iBAAiB,EAAA;IA5BzB;MAiCM,mCAAmC;MACnC,kBAAkB,EAAA;IAlCxB;;MAuCQ,yBAAyB;MACzB,cAAc,EAAA;EAxCtB;IA6CI,YAAY;IACZ,4BAA4B;IAC5B,+BAA+B,EAAA;;AAKnC;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,kBAAkB,EAAA;;AAGpB;EACE,oBAAoB;EACpB,WAAW;EACX,oBAAoB;EACpB,qBAAqB;EACrB,yBAAyB,EAAA;EAL3B;IAQI,yBAAyB;IACzB,YAAY;IACZ,YAAY,EAAA;IAVhB;MAaM,2BAA2B;MAC3B,YAAY,EAAA;EAdlB;IAmBI,2BAA2B;IAC3B,YAAY;IACZ,YAAY,EAAA;IArBhB;MAwBM,2BAA2B;MAC3B,YAAY,EAAA","sourcesContent":[".layer-search {\n  padding: 0.5rem;\n  margin-bottom: 20px;\n\n  .input-group {\n    width: 100%;\n\n    .icon-wrapper {\n      border: none;\n      border-top-left-radius: 3px;\n      border-bottom-left-radius: 3px;\n      svg {\n        color: #dcd7d7;\n      }\n    }\n\n    input {\n      background-color: #002754;\n      border-top-right-radius: 3px;\n      border-bottom-right-radius: 3px;\n      color: #cfc9c9;\n      border: none;\n\n      &::placeholder {\n        color: #dcd7d7;\n      }\n\n      &:focus {\n        box-shadow: unset;\n      }\n    }\n\n    &:focus-within {\n      box-shadow: 0 0 0 0.25rem #01254fd4;\n      border-radius: 3px;\n    }\n\n    .icon-wrapper,\n    input { \n        background-color: #01254f;\n        color: #dcd7d7;\n    }\n  }\n\n  .btn-clear {\n    color: white;\n    border-top-right-radius: 3px;\n    border-bottom-right-radius: 3px;\n  }\n\n}\n\n.queried-layers {\n  max-height: 300px;\n  overflow-y: auto;\n  background-color: #0E1937;\n  color: #dcd7d7;\n  border-radius: 3px;\n}\n\n.suggestions-list {\n  border-radius: unset;\n  width: 100%;\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  background-color: #03274E;\n\n  .list-group-item {\n    background-color: #03274E;\n    color: white;\n    border: none;\n\n    &:hover {\n      background-color: #00153375;\n      color: white;\n    }\n  }\n\n  button {\n    background-color: #002044b5;\n    color: white;\n    border: none;\n\n    &:hover {\n      background-color: #00153375; \n      color: white;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
